import React from 'react'
import { Link, useSearchParams } from 'react-router-dom'

import { useAuth } from 'modules/Auth/hooks/useAuth'
import { useListenUserProfileQuery } from 'modules/Users/userApi'
import { useListenCoachOrgSlugQuery } from 'modules/PageBuilder/pageBuilderApi'
import { SELL, STRIPE_SETUP } from 'modules/App/components/Header'
import { Skeleton } from 'common/components/Skeleton/Skeleton'
import { useSellableProducts } from 'modules/ProductInfo/hooks/useSellableProducts'
import { ReportsLinkLine, ShareLinks } from 'modules/ProductInfo/components/ShareLinkMenu/ShareLinkMenu'

export const SHARE = '/share'

const cardClasses = 'bg-white rounded-xl border-2 border-gray-200 p-4'

// ?product=subscription or ?product={oneTimeProductId} shows just that product.
function Share() {
  const { userId } = useAuth()
  const { data: profile } = useListenUserProfileQuery({ userId })
  const coachOrgId = profile?.coachOrgId || ''
  const [searchParams] = useSearchParams()
  const productKey = searchParams.get('product')

  const { data: coachOrgSlugData } = useListenCoachOrgSlugQuery({ coachOrgId })
  const coachOrgSlugLoading = coachOrgSlugData === undefined || coachOrgSlugData?.isLoading
  const coachOrgSlug = coachOrgSlugLoading ? '' : coachOrgSlugData || ''
  const { products, isLoading: productsLoading } = useSellableProducts({ coachOrgId })

  const pickedProduct = productKey ? products.find((p) => p.key === productKey) : null
  const shownProducts = pickedProduct ? [pickedProduct] : products

  return (
    <div className='flex flex-col min-h-screen bg-offWhite px-4 md:px-16'>
      <div className='w-full max-w-[640px] mx-auto mt-6 md:mt-12 mb-16'>
        <h1 className='font-bold text-5xl text-tBlack mb-2'>Share</h1>
        <p className='text-gray-500 mb-8'>Post these links on your socials.</p>
        {coachOrgSlugLoading || productsLoading ? (
          <Skeleton className='rounded-xl min-h-[240px] border-2 border-gray-200' />
        ) : !coachOrgSlug ? (
          <p className={`${cardClasses} text-tBlack`}>
            Your app needs a link handle first. Set it in{' '}
            <Link to={STRIPE_SETUP} className='text-tGreen font-semibold underline'>
              Sell settings
            </Link>
            .
          </p>
        ) : !products.length ? (
          <p className={`${cardClasses} text-tBlack`}>
            Your share links appear here once a product is ready for sale. Set one up in{' '}
            <Link to={SELL} className='text-tGreen font-semibold underline'>
              Products
            </Link>
            .
          </p>
        ) : (
          <>
            {productKey && !pickedProduct && (
              <p className='text-sm text-tGray-dark mb-4'>
                That product is not ready for sale yet. Here are the ones that are.
              </p>
            )}
            <div className='flex flex-col gap-4'>
              {shownProducts.map((product) => (
                <section key={product.key} className={cardClasses}>
                  <ShareLinks
                    coachSlug={coachOrgSlug}
                    pagePath={product.path}
                    title={product.name}
                    showReportsLine={false}
                  />
                </section>
              ))}
            </div>
            {pickedProduct && products.length > 1 && (
              <Link to={SHARE} className='inline-block mt-4 text-sm text-tGreen font-semibold underline'>
                Show all products
              </Link>
            )}
            <ReportsLinkLine className='mt-6' />
          </>
        )}
      </div>
    </div>
  )
}

export default Share
